var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKbvV16TipsModalAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 20,
    viewBox: "0 0 24.262 19.084",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2 -4.976)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f62e39",
    d: "M25.4,22.463H23.662v-2.6a1.733,1.733,0,0,0-1.733-1.733H20.2a1.733,1.733,0,0,0-1.733,1.733v2.6H16.73V18.131A1.733,1.733,0,0,0,15,16.4H13.264a1.733,1.733,0,0,0-1.733,1.733v4.332H9.8V7.733A1.733,1.733,0,0,0,8.065,6H6.332A1.733,1.733,0,0,0,4.6,7.733v14.73H2.866a.866.866,0,1,0,0,1.733H25.4a.866.866,0,0,0,0-1.733Z",
    transform: "translate(0 -0.137)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f62e39",
    d: "M27.74,16.515l-3.31-3.31a5.209,5.209,0,1,0-1.225,1.225l3.31,3.31a.866.866,0,1,0,1.225-1.225ZM20.2,13.662A3.466,3.466,0,1,1,23.662,10.2,3.466,3.466,0,0,1,20.2,13.662Z",
    transform: "translate(-1.732)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKbvV16TipsModalAnalysis);
export default __webpack_public_path__ + "static/media/kbv-v16-tips-modal-analysis.ae2069e3e33caa44ac1f373f28ef3c93.svg";
export { ForwardRef as ReactComponent };